// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__2Q7Gp","active":"styles_active__3TIv0"};